import React from 'react';
import './FleetConsole.css';

import { withTranslation } from 'react-i18next/hooks';

import { getLang } from '../functions/lang'

import { Container } from '@material-ui/core';

//import {Routes, Route, Outlet } from "react-router-dom";
//import { BrowserRouter } from "react-router-dom";

import { ServerApi, PTT_REQUEST_TYPES, OBJ_TYPES } from './api/ServerApi';
import { base64toGuid, getBase64ID, getIndexByID, getObjectByID } from '../api/helpers';
import { FILESTORAGE_MAX_FILE_SIZE } from './api/ServerApi';
//import { Dialog } from './components/Dialog';
//import Logo from './components/Logo';
import { isString } from 'util';


import {ConnectionProgress} from '../pages/ConnectionProgress';
import { Login } from '../pages/Login';
import { ServerConsole } from './pages/ServerConsole/ServerConsole';
//import { NetworkEditor } from './pages/NetworkEditor/NetworkEditor';
//import { ServerMonitor } from './pages/ServerMonitor';
//import { EditDeviceSettingsDialog } from './pages/DeviceSettings/EditDeviceSettingsDialog';
//import { UserPropertiesDialog } from './pages/ServerConsole/UserPropertiesDialog';
//import { GroupPropertiesDialog } from './pages/ServerConsole/GroupPropertiesDialog';

import { EventLogger, EVENT_TYPE } from './api/EventLogger';

//import { SettingsDialog } from './pages/SettingsDialog/SettingsDialog';
import { getSettingsInstance, getSpeedInMs } from './api/Settings';

import * as dev from '../api/dev'
import FileStorage from './api/FileStorage';
import IndexedDb from '../api/IndexedDb';
import { parseFile, thumbnailify } from '../api/file';
import SqlRequest from '../api/sql/SqlRequest';
import { ResourceReader } from './api/ResourceReader';
import { GeofencesStorage } from './api/Geofences';
import { GeofenceLocator } from './api/GeofenceLocator';
import { BrokenImage } from '@material-ui/icons';
import { AlertLogger } from './api/AlertLogger';
import { AlertDialog } from '../components/AlertDialog';
import { KmlLayersStorage } from './api/KmlLayers';
//import { appendFile } from 'fs';


//export default 
class FleetConsole_ extends React.Component {

    constructor(props) {
        super(props);

        const {t} = props 

        let login = localStorage.getItem('login');
        let password = sessionStorage.getItem('password');
        let serveraddress = localStorage.getItem('serveraddress')
        if(!serveraddress) serveraddress = window.location.host

        

        this.state = {
            vendorName: 'WalkieFleet',
            isLogged: false,
            isConnecting: false, //this.isConnecting(),
            authUser: {
                login: isString(login) ? login : '',
                password: isString(password) ? password : '',
                serveraddress: isString(serveraddress) ? serveraddress : ''
            },
            apiError: false,
            apiMessage: '',
            networks: [],
            page: 'login',
            networkEditor: {
                networkID: '',
                networkSettings: null
            },
            deviceSettingsEditor: {
                networkID: '',
                deviceID: '',
                deviceSettings: null
            },
            userPropertiesDialog: {
                networkID: '',
                userID: '',
                deviceID: '',
                avatar: null,
                properties: null
            },
            groupPropertiesDialog: {
                networkID: '',
                groupID: '',
                properties: null
            },
            dynamicGroupPropertiesDialog: {
                networkID: '',
                groupID: '',
                properties: null,
                open: false
            },
            settingsDialog: null,
            groupPatchesDialog: null,
            calls: [],
            unreadMessages: [],
            emergency: [],
            geofences: [],
            geofencePaintID: null,
            geofenceSelectedShape: null,

            kmlLayers: [],
            kmlRefreshTimer: [],

        };

        //this.login();
        //console.log('new EventLogger')

        this.indexedDB = new IndexedDb('walkiefleet', 28)
        this.eventLogger = new EventLogger(this.indexedDB)
        this.fileStorage = new FileStorage(this.indexedDB)
        this.alertLogger = new AlertLogger(this.indexedDB)

        this.eventLogger.addDeleteListener(this.handleDeleteEvent.bind(this))
        this.geofencesStorage = new GeofencesStorage(this.indexedDB, this.onGeofencesConnect.bind(this))
        this.kmlLayersStorage = new KmlLayersStorage(this.indexedDB, this.onKmlLayersConnect.bind(this))

        this.indexedDB.connect()

        this.handleAppAction = this.handleAppAction.bind(this)

        this.geofenceLocator = new GeofenceLocator(this.handleAppAction, this.props.t)

        this.api = null

        //this.settings = new Settings()
        this.settings = getSettingsInstance(t)

    }

    componentDidMount(){
        this.setTitle()
    }
    componentDidUpdate(){
        this.setTitle()
    }
    setTitle(){
        document.title = this.props.config.title + ' Dispatcher'
    }

    componentWillUnmount(){
        this.stopApi()
    }


    onGeofencesConnect(){
        this.handleAppAction({
            type: 'GEOFENCES_GET', 
            onComplete: this.onGeofencesGet.bind(this),
            onError: this.onGeofencesError.bind(this)
        })
    }

    onGeofencesGet(geofences){
        //alert('onGeofenceGet')
        //console.log('onGeofenceGet')
        //console.log(geofences)

        //this.setState({geofences: geofences})
        this.onGeofencesChange(geofences)
    }

    onGeofencesError(event){
        console.log('onGeofenceError')
        console.log(event)
    }


    onKmlLayersConnect(){
        this.handleAppAction({
            type: 'KML_LAYERS_GET', 
            onComplete: this.onKmlLayersGet.bind(this),
            onError: this.onKmlLayersError.bind(this)
        })
    }

    onKmlLayersGet(kmlLayers){
        //alert('onGeofenceGet')
        //console.log('onGeofenceGet')
        //console.log(geofences)

        //this.setState({geofences: geofences})
        this.onKmlLayersChange(kmlLayers)

        this.bindKmlLayersRefreshTimer(kmlLayers)
    }

    onKmlLayersError(event){
        console.log('onKmlLayersError')
        console.log(event)
    }

    onKmlLayersChange(kmlLayers){

        this.setState({kmlLayers: kmlLayers})

    }

    bindKmlLayersRefreshTimer(kmlLayers){

        let kmlRefreshTimer = this.state.kmlRefreshTimer
        //alert('bindKmlLayersRefreshTimer()')
        //console.log('bindKmlLayersRefreshTimer()')
        //console.log(kmlRefreshTimer)

        kmlLayers.forEach( kmlLayer => {
            if(kmlLayer.ShowOnMap && kmlLayer.RefreshInterval ){

                let ID = kmlLayer.ID 

                //alert('updateKmlCurrentUrl() '+ ID + ' ' + kmlLayer.RefreshInterval)
                this.updateKmlCurrentUrl(ID)

                let kmlLayerTimer = {
                    ID: kmlLayer.ID,
                    interval: kmlLayer.RefreshInterval,
                    timer: window.setInterval(
                        ()=>{ 
                            //alert('kmlLayerTimer '+ ID + ' ' + kmlLayer.RefreshInterval)
                            this.updateKmlCurrentUrl(ID)
                        },
                        kmlLayer.RefreshInterval * 1000
                    )

                }

                kmlRefreshTimer.push(kmlLayerTimer)

            }
        }
        )

        this.setState({kmlRefreshTimer: kmlRefreshTimer})

    }

    updateKmlCurrentUrl(ID){

        let kmlLayer = getObjectByID(ID, this.state.kmlLayers)
        let kmlTimer = getObjectByID(ID, this.state.kmlRefreshTimer)

        //console.log('updateKmlCurrentUrl')
        //console.log(kmlLayer)
        //console.log(kmlTimer)
        
        let index = kmlLayer.Url.indexOf('?')
        //alert('index of ? '+index +  ' ' + kmlLayer.Url)

        let CurrentUrl = kmlLayer.Url + (index>=0 ? '&' : '?' ) + (new Date().getTime())
        
        //console.log('CurrentUrl=' + CurrentUrl)

        let kmlLayers = [...this.state.kmlLayers]
        index = getIndexByID(ID, kmlLayers)
        if(index>=0) kmlLayers[index].CurrentUrl = CurrentUrl

        this.onKmlLayersChange(kmlLayers)
        
    }

    updateKmlRefreshTimer(kmlLayer){

        let ID = kmlLayer.ID

        //console.log('updateKmlRefreshTimer '+ ID)
        //alert('updateKmlRefreshTimer '+ ID)

        //let kmlLayer = getObjectByID(ID, this.state.kmlLayers)

        let kmlTimer = getObjectByID(kmlLayer.ID, this.state.kmlRefreshTimer)

        let kmlRefreshTimer = [...this.state.kmlRefreshTimer]

        if(kmlLayer.RefreshInterval===0 && kmlTimer){

            clearInterval(kmlTimer.timer)
            //console.log('clearInterval1 '+ kmlTimer.timer + '; '+ kmlTimer.interval)

            let index = getIndexByID(ID, kmlRefreshTimer)

            //console.log('splice index1 ' + index)
            
            if(index>=0) kmlRefreshTimer.splice(index, 1);

        }

        if(kmlTimer && kmlLayer.RefreshInterval && kmlLayer.RefreshInterval != kmlTimer.interval){

            clearInterval(kmlTimer.timer)
            //console.log('clearInterval2 '+ kmlTimer.timer + '; '+ kmlTimer.interval)

            let index = getIndexByID(ID, kmlRefreshTimer)
            //console.log('splice index2  ' + index)
            if(index>=0) kmlRefreshTimer.splice(index, 1);

            let kmlLayerTimer = {
                ID: kmlLayer.ID,
                interval: kmlLayer.RefreshInterval,
                timer: window.setInterval(
                    ()=>{ 
                        //alert('kmlLayerTimer '+ ID + ' ' + kmlLayer.RefreshInterval)
                        this.updateKmlCurrentUrl(ID)
                    },
                    kmlLayer.RefreshInterval * 1000
                )

            }            

            kmlRefreshTimer.push(kmlLayerTimer)

        }

        if(!kmlTimer && kmlLayer.RefreshInterval){
            let kmlLayerTimer = {
                ID: kmlLayer.ID,
                interval: kmlLayer.RefreshInterval,
                timer: window.setInterval(
                    ()=>{ 
                        //alert('kmlLayerTimer '+ ID + ' ' + kmlLayer.RefreshInterval)
                        this.updateKmlCurrentUrl(ID)
                    },
                    kmlLayer.RefreshInterval * 1000
                )

            }

            let index = getIndexByID(ID, kmlRefreshTimer)
            //console.log('splice index2  ' + index)
            if(index>=0) kmlRefreshTimer.splice(index, 1);

            kmlRefreshTimer.push(kmlLayerTimer)
        }


        //alert('before updateKmlRefreshTimer setstate')
        this.setState({kmlRefreshTimer: kmlRefreshTimer})

        //console.log('updateKmlRefreshTimer setstate')
        //console.log(kmlRefreshTimer)
        //alert('updateKmlRefreshTimer setstate')

    }



    /*
    isConnecting(){
      let user = this.getAuthUser();
      return user.login && user.password && user.serveraddress;
    }
    */

    /*
    getLang() {
        let lang = this.props.i18n.language
        if (lang.indexOf('-')) {
            lang = lang.split('-')[0]
        }
        let { langs } = this.props.i18n.options
        let defaultLang = null
        let existLang = null
        for (let key in langs) {
            if (key === lang) {
                existLang = key
                break
            }
            if (langs[key].default === true) {
                defaultLang = key
            }
        }

        if (!existLang) {
            lang = defaultLang
            this.props.i18n.changeLanguage(lang)
        }

        return lang
    }
    */

    login(login, password, serveraddress) {
        if (login) {
            localStorage.setItem("login", login);
            sessionStorage.setItem("password", password);
            localStorage.setItem("serveraddress", serveraddress);

            this.setState({ isConnecting: true, page: 'connecting' });
            this.startApi(serveraddress, login, password, this.props.config);
        }
    }

    startApi(serveraddress, login, password, config) {
        
        let options = {
            //settings: this.settings,
            eventLogger: this.eventLogger,
            fileStorage: this.fileStorage,
            onError: this.handleApiError.bind(this),
            onClose: this.handleApiClose.bind(this),
            onConnect: this.handleApiConnect.bind(this),
            onLoginComplete: this.handleLoginComplete.bind(this),
            onNetworksChanged: this.handleNetworksChanged.bind(this),
            onGpsChange: this.handleGpsChange.bind(this),
            onAvatarUpdate: this.handleAvatarUpdate.bind(this),
            onPttCall: this.handlePttCall.bind(this),
            onUnreadMessagesChanged: this.handleUnreadMessagesChanged.bind(this),
            onEmergency: this.handleEmergency.bind(this),
            onAction: this.handleAppAction.bind(this),
            config: config
        }
        console.log('start api; server='+serveraddress)
        this.api = new ServerApi(serveraddress, login, password, options)
        this.api.connect();
    }

    stopApi(){
        if(this.api){
            this.api.close()
            this.api = null
        }
    }


    //login form callback
    handleLogin(login, password, serveraddress) {
        this.setState({
            authUser: {
                login: login,
                password: password,
                serveraddress: serveraddress
            }
        })
        this.login(login, password, serveraddress);
    }

    handleLoginComplete(){
        this.eventLogger.setDispatcher(this.api.login)
        this.eventLogger.add({ type: EVENT_TYPE.TYPE_LOGIN, sender: this.api.login, note: '' })
        
        this.alertLogger.setDispatcherName(this.api.login)
        this.alertLogger.setDispatcherID(this.api.userID)
    }

    handleApiError(err, connectCount) {
        console.log('handleApiError error')
        console.log(err)
        if (isString(err)) {
            this.setState({ apiError: true, apiMessage: err })
        } else {
            if (err.type === 'login') {
                this.setState({ apiError: true, apiMessage: err.message, page: 'login', isConnecting: true })
            } else {
                let errorStr = JSON.stringify(err, ["message", "arguments", "type", "name"]);
                this.setState({ apiError: true, apiMessage: 'An error occured: ' + errorStr + ' ' + connectCount })
                console.log(err)
            }
        }
    }

    handleApiClose(evt, connectCount) {
        //console.log('handleApiClose')
        //console.log(evt)
        switch (evt.code) {
            case 1006:
                this.setState({ apiError: true, apiMessage: 'Try to Connect: ' + connectCount })
                break;
            case 1005:
                //No Status Received - regular close connection
                if (this.state.page !== 'login') {
                    this.setState({ 
                        apiError: true, 
                        apiMessage: 'Try to Connect: ' + connectCount,
                        isConnecting: true
                    })
                }
                break;

            default:
                this.setState({ 
                    apiError: true, 
                    apiMessage: 'handleApiClose:' + evt.code + '; ' + JSON.stringify(evt) 
                })
        }
    }

    //on message CONFIG_SERVER_RESPONSE_ACK
    handleApiConnect() {
        this.setState({ 
            isLogged: true, 
            isConnecting: false, 
            page: 'console',
            apiError: false, 
            apiMessage: ''
        })
    }

    handleNetworksChanged(nets) {
        //console.log('handleNetworksChanged')
        //console.log(nets)
        this.setState({ networks: nets })
    }

    handleGpsChange(device){
        this.geofenceLocator.process(device)
    }

    handleDeleteEvent(event){
        //console.log('onDeleteEvent')
        //console.log(event)
        switch(event.type){
            case EVENT_TYPE.TYPE_FILE_GROUP:
            case EVENT_TYPE.TYPE_FILE_PRIVATE:
            case EVENT_TYPE.TYPE_IMAGE_GROUP:
            case EVENT_TYPE.TYPE_IMAGE_PRIVATE:
                this.fileStorage.delete(event.ref_id)
                break
            default: console.error('Unknown switch case for event.type = '+event.type)
        }
    }

    handleAppAction(action) {
        const { i18n } = this.props
        //console.log('App.action')
        //console.log(action)


        switch (action.type) {
            case 'NETWORK_EDITOR_SHOW':
                this.setState({
                    page: 'networkeditor',
                    networkEditor: { networkID: action.networkID, networkSettings: null }
                });
                this.api.queryGetNetworkSettings(action.networkID, (networkSettings) => {
                    if (this.state.networkEditor && this.state.networkEditor.networkID) {

                        for(let i=0; i<networkSettings.Groups.length; i++){
                            networkSettings.Groups[i].GUID = base64toGuid(networkSettings.Groups[i].ID)
                            //alert(i + ' ' +networkSettings.Groups[i].GUID) 
                        }

                        this.setState({
                            networkEditor: {
                                networkID: action.networkID,
                                networkSettings: networkSettings
                            }
                        })
                    }
                })
                break;

            case 'NETWORK_EDITOR_SAVE':
                this.api.querySaveNetworkSettings(action.networkSettings);
                this.setState({ networkEditor: null, page: '' })
                break;

            case 'NETWORK_EDITOR_CLOSE':
                this.setState({ networkEditor: null, page: '' })
                break;

            case 'ADD_DYNAMIC_GROUP':
                this.setState({
                    dynamicGroupPropertiesDialog: {
                        networkID: action.networkID,
                        group: null,
                        open: true
                }})
                break;

            case 'DYNAMIC_GROUP_PROPERTIES_GET':{

                const { networkID, groupID, groupGUID } = action
                let requestID = getBase64ID()

                //alert('DYNAMIC_GROUP_PROPERTIES_GET: networkID='+networkID+'; groupID='+groupID+'; groupGUID='+groupGUID)

                this.api.queryGroupInfoRequest(networkID, [groupGUID], requestID, (message)=>{

                    if(message.GroupInfos){

                        let groupInfo = getObjectByID(groupID, message.GroupInfos)
                        groupInfo.Type = 1 //temp group

                        //console.log('groupInfo')
                        //console.log(groupInfo)
                        //alert('requerst complete')

                        if(action.onComplete) action.onComplete(groupInfo)
 
                    }

                })


                break
            }

            case 'DYNAMIC_GROUP_PROPERTIES_DIALOG_SHOW':{
                
                const { networkID, groupID, groupGUID } = action
                let requestID = getBase64ID()
                this.api.queryGroupInfoRequest(networkID, [groupGUID], requestID, (message)=>{

                    if(message.GroupInfos){
                        //console.log('request DYNAMIC_GROUP_PROPERTIES_DIALOG_SHOW')
                        //console.log(message.GroupInfos)

                        let groupInfo = getObjectByID(groupID, message.GroupInfos)
                        groupInfo.Type = 1 //temp group
                        //console.log('groupInfo')
                        //console.log(groupInfo)
                        this.setState({
                            dynamicGroupPropertiesDialog: {
                                networkID: action.networkID,
                                group: groupInfo,
                                open: true
                        }})

                    }
                })
                //GROUP_INFO_REQUEST
                break;
            }

            case 'DYNAMIC_GROUP_PROPERTIES_DIALOG_SAVE':{

                //console.log( 'DYNAMIC_GROUP_PROPERTIES_DIALOG_SAVE')
                //console.log( action)

                const { networkID, group } = action

                let opType = group.DtCreated ? 3 : 1 

                if(group.DtCreated == undefined){
                    group.DtCreated = Date.now()
                }
                
                group.Users  = group.Users.map(item=>item.ID)

                //console.log(group)

                this.api.quickFleetRequest(networkID, OBJ_TYPES.TYPE_GROUPS, opType, group)

                this.setState({
                    dynamicGroupPropertiesDialog: {
                        networkID: null,
                        group: null,
                        open: false
                }})

                break
            }

            case 'DYNAMIC_GROUP_PROPERTIES_DIALOG_DELETE':{

                //console.log( 'DYNAMIC_GROUP_PROPERTIES_DIALOG_DELETE')
                //console.log( action)

                const { networkID, group } = action
                let opType = 2

                this.api.quickFleetRequest(networkID, OBJ_TYPES.TYPE_GROUPS, opType, group)

                this.setState({
                    dynamicGroupPropertiesDialog: {
                        networkID: null,
                        group: null,
                        open: false
                }})
                break
            }

            case 'DYNAMIC_GROUP_PROPETIES_DIALOG_CLOSE':{
                this.setState({
                    dynamicGroupPropertiesDialog: {
                        networkID: null,
                        group: null,
                        open: false
                }})
                break
            }

            case 'DYNAMIC_GROUP_UPDATE':{
                //console.log(action)
                //alert('DYNAMIC_GROUP_UPDATE strt')

                const { networkID, group} = action

                let opType = group.DtCreated ? 3 : 1 
                this.api.quickFleetRequest(networkID, OBJ_TYPES.TYPE_GROUPS, opType, group)

                //alert('DYNAMIC_GROUP_UPDATE end')
                break
            }

            case 'SET_LANGUAGE':
                const lang = action.lang;
                this.props.i18n.changeLanguage(lang);
                break;

            case 'LOGOUT':
                this.setState({
                    isLogged: false,
                    isConnecting: false,
                    page: 'login',
                    apiError: false,
                    apiMessage: ''
                })
                this.api.close();
                break;

            case 'LANGUAGE_CHANGE':
                //todo???
                break;

            case 'DEVICESETTINGS_EDITOR_SHOW':
                const { networkID, deviceID, userID } = action
                const requestID = getBase64ID()
                this.api.queryGetDeviceSettings(networkID, deviceID, requestID, deviceSettings => {
                    this.setState({
                        deviceSettingsEditor: {
                            networkID: networkID,
                            deviceID: deviceID,
                            userID: userID,
                            deviceSettings: deviceSettings
                        }
                    });
                });
                break;

            case 'DEVICE_SETTINGS_EDITOR_CLOSE':
                this.setState({
                    deviceSettingsEditor: {
                        networkID: '',
                        deviceID: '',
                        deviceSettings: null
                    }
                });
                break;

            case 'DEVICE_SETTINGS_EDITOR_SAVE': {
                const { networkID, userID, deviceID, deviceSettings } = action
                this.api.querySaveDeviceSetings(networkID, userID, deviceID, deviceSettings)
                this.setState({
                    deviceSettingsEditor: {
                        networkID: '',
                        deviceID: '',
                        deviceSettings: null
                    }
                });
                break;
            }


            case 'GPS_DEVICE_REQUEST': {
                const { networkID, deviceID, groupID } = action
                this.api.queryGpsDeviceRequest(networkID, deviceID, groupID)
                break;
            }


            case 'USER_PROPERTIES_DIALOG_SHOW': {
                const { networkID, deviceID, userID } = action
                const network = getObjectByID(networkID, this.state.networks)
                const device = getObjectByID(deviceID, network.devices)
                let avatar = null

                if (device && device.AvatarHash) {
                    avatar = localStorage.getItem(device.AvatarHash)
                }

                if (device && device.AvatarHash && !avatar) {
                    this.api.queryAvatar(device.AvatarHash, networkID)
                }

                let pollingTime = this.settings.get('defaultPollingTime'), pollingEnabled = false
                if (device && device.locationRequest) {
                    pollingEnabled = true
                    pollingTime = device.locationRequest.period
                }

                this.setState({
                    userPropertiesDialog: {
                        networkID: networkID,
                        deviceID: deviceID,
                        userID: userID,
                        avatar: avatar,
                        properties: {
                            pollingTime: pollingTime,
                            pollingEnabled: pollingEnabled,
                            profileID: ''
                        }
                    }
                });
                break
            }

            case 'USER_PROPETIES_DIALOG_CLOSE': {
                this.setState({
                    userPropertiesDialog: {
                        networkID: '',
                        deviceID: '',
                        userID: '',
                        profileID: null,
                        properties: null
                    }
                });
                break
            }

            case 'USER_PROPERTIES_DIALOG_SAVE': {
                const { networkID, deviceID, properties } = action //userID,

                //console.log('USER_PROPERTIES_DIALOG_SAVE')
                //console.log(action)
                //console.log('networkID=' + networkID)
                let networks = this.state.networks
                //console.log(networks)
                let network = getObjectByID(networkID, networks)
                //console.log(network)
                let device = getObjectByID(deviceID, network.devices)
                //console.log(device)

                if(device){
                    if (properties.pollingEnabled && properties.pollingTime) {
                        let requestID = this.api.queryGpsDeviceRequest(networkID, deviceID, null, properties.pollingTime)
                        device.locationRequest = {
                            period: properties.pollingTime,
                            requestID: requestID
                        }
                    } else {
                        if (device.locationRequest) {
                            this.api.queryGpsDeviceCancel(networkID, device.locationRequest.requestID)
                            delete device.locationRequest
                        }
                    }
                }

                this.setState({
                    networks: networks,
                    userPropertiesDialog: {
                        networkID: '',
                        deviceID: '',
                        userID: '',
                        profileID: null,
                        properties: null
                    }
                })

                break;
            }

            case 'GROUP_PROPERTIES_DIALOG_SHOW': {
                const { networkID, groupID } = action
                const network = getObjectByID(networkID, this.state.networks)
                const group = getObjectByID(groupID, network.groups)

                let pollingTime = this.settings.get('defaultPollingTime'), pollingEnabled = false
                if (group.locationRequest) {
                    pollingEnabled = true
                    pollingTime = group.locationRequest.period
                }

                this.setState({
                    groupPropertiesDialog: {
                        networkID: networkID,
                        groupID: groupID,
                        properties: {
                            pollingTime: pollingTime,
                            pollingEnabled: pollingEnabled,
                        }
                    }
                });
                break
            }

            case 'GROUP_PROPETIES_DIALOG_CLOSE': {
                this.setState({
                    groupPropertiesDialog: {
                        networkID: '',
                        groupID: '',
                        properties: null
                    }
                });
                break
            }

            case 'GROUP_PROPERTIES_DIALOG_SAVE': {
                const { networkID, groupID, properties } = action

                //console.log('GROUP_PROPERTIES_DIALOG_SAVE')
                //console.log(action)
                //console.log('networkID=' + networkID)
                let networks = this.state.networks
                //console.log(networks)
                let network = getObjectByID(networkID, networks)
                //console.log(network)
                let group = getObjectByID(groupID, network.groups)
                //console.log(group)

                if (properties.pollingEnabled && properties.pollingTime) {
                    let requestID = this.api.queryGpsDeviceRequest(networkID, null, groupID, properties.pollingTime)
                    group.locationRequest = {
                        period: properties.pollingTime,
                        requestID: requestID
                    }
                } else {
                    if (group.locationRequest) {
                        this.api.queryGpsDeviceCancel(networkID, group.locationRequest.requestID)
                        delete group.locationRequest
                    }
                }
                this.setState({
                    networks: networks,
                    groupPropertiesDialog: {
                        networkID: '',
                        groupID: '',
                        properties: null
                    }
                })

                break
            }

            case 'GROUP_SOUND_MUTE': {
                const { networkID, groupID } = action
                this.api.groupSoundMute(networkID, groupID)
                break
            }

            case 'SETTINGS_DIALOG_SHOW': {
                let settings = this.settings.getAll()
                settings.language = getLang(i18n)

                this.setState({
                    settingsDialog: {
                        settings: settings
                    }
                })
                break
            }

            //case 'SETTINGS_EDITOR_CLOSE':
            case 'SETTINGS_DIALOG_CLOSE':
                this.setState({
                    settingsDialog: null
                })
                break

            case 'SETTINGS_EDITOR_SAVE': {
                let { settings } = action
                //console.log('settings')
                //console.log(settings)

                if (getLang(i18n) !== settings.language) {
                    this.props.i18n.changeLanguage(settings.language);
                }
                delete settings.language

                this.settings.save(settings)

                this.setState({
                    settingsDialog: null
                })
                break
            }

            case 'PTT_START': {
                const { deviceID, groupID, networkID } = action
                //console.log(action)
                if (deviceID) {
                    this.api.startPTT(deviceID, PTT_REQUEST_TYPES.PRIVATE_VOICE_CALL_START, networkID)
                } else if (groupID) {
                    this.api.startPTT(groupID, PTT_REQUEST_TYPES.GROUP_VOICE_CALL_START, networkID)
                }
                break
            }

            case 'PTT_STOP': {
                const { deviceID, groupID, networkID } = action
                if (deviceID) {
                    this.api.stopPTT(deviceID, PTT_REQUEST_TYPES.PRIVATE_VOICE_CALL_STOP, networkID)
                } else if (groupID) {
                    this.api.stopPTT(groupID, PTT_REQUEST_TYPES.GROUP_VOICE_CALL_STOP, networkID)
                }

                break
            }


            case 'SEND_MESSAGE': {
                //console.log('action')
                //console.log(action)
                const { message, userID, deviceID, groupID, targetType, networkID } = action
                this.api.querySendTextMessage(message, userID, deviceID, groupID, targetType, networkID)
                break
            }

            case 'SEND_IMAGE':{
                const { file, message, userID, deviceID, groupID, targetType, networkID } = action

                thumbnailify(file, 100, (blob)=>{

                    //console.log('thumb blob')
                    //console.log(blob)

                    const jobID = this.api.querySendFile(blob, file, message, userID, deviceID, groupID, targetType, networkID)

                    //save thumb
                    const thumbObject = {
                        job_id: jobID,
                        name: file.name,
                        size: blob.size,
                        mime_type: file.type,
                        type: 0,
                        state: 0,
                        network_id: networkID
                    }

                    this.fileStorage.addFile(thumbObject, fileID => {
                        let num = 0
                        parseFile(blob, (val)=>{
                            const data = btoa(val)
                            const fileChunk = {
                                file_id: fileID,
                                num: num,
                                data: data
                            }
                            //console.log('fileChunk')
                            //console.log(fileChunk)
                            this.fileStorage.addChunk(fileChunk)
                            num++
                        })
                    })

                    //save image
                    const fileObject = {
                        job_id: jobID,
                        name: file.name,
                        size: file.size,
                        mime_type: file.type,
                        type: 1,
                        state: 0,
                        network_id: networkID
                    }

                    this.fileStorage.addFile(fileObject, fileID => {
                        let num = 0
                        let totalBytes = 0

                        if(file.size < FILESTORAGE_MAX_FILE_SIZE ){
                            parseFile(file, (val)=>{
                                const data = btoa(val)
                                totalBytes += val.length
                                const fileChunk = {
                                    file_id: fileID,
                                    num: num,
                                    data: data
                                }
                                //console.log('fileChunk')
                                //console.log(fileChunk)
                                this.fileStorage.addChunk(fileChunk)
                                num++

                                if(totalBytes >= file.size){
                                    //alert('save last chunk')
                                    //console.log('save last chunk')
                                    //todo update status
                                }
                            })
                        }
                    })

                })

                break
            }

            case 'SEND_FILE': {
                //console.log('action')
                //console.log(action)
                const { file, message, userID, deviceID, groupID, targetType, networkID } = action
                const jobID = this.api.querySendFile(null, file, message, userID, deviceID, groupID, targetType, networkID)
                
                const fileObject = {
                    job_id: jobID,
                    name: file.name,
                    size: file.size,
                    mime_type: file.type,
                    type: 1,
                    network_id: networkID
                }
                this.fileStorage.addFile(fileObject, fileID => {

                    if(file.size < FILESTORAGE_MAX_FILE_SIZE ){
                        let num = 0
                        parseFile(file, (val)=>{
                            const data = btoa(val)
                            const fileChunk = {
                                file_id: fileID,
                                num: num,
                                data: data
                            }
                            //console.log('fileChunk')
                            //console.log(fileChunk)
                            this.fileStorage.addChunk(fileChunk)
                            num++
                        })
                    }

                })

                break
            }

            case 'SUBSCRIBE_MESSAGES': {
                const userID = action.userID ? action.userID : ''
                const deviceID = action.deviceID ? action.deviceID : ''
                const groupID = action.groupID ? action.groupID : ''
                const networkID = action.networkID
                this.api.subscribeMessages(userID, deviceID, groupID, networkID)
                break
            }

            case 'UNSUBSCRIBE_MESSAGES': {
                const userID = action.userID ? action.userID : ''
                const deviceID = action.deviceID ? action.deviceID : ''
                const groupID = action.groupID ? action.groupID : ''
                const networkID = action.networkID
                this.api.unsubscribeMessages(userID, deviceID, groupID, networkID)
                break
            }

            case 'MESSAGE_MARK_READ': {
                const { jobID, networkID } = action
                this.api.markMessageRead(jobID, networkID)
                break
            }

            case 'MESSAGE_MARK_ALL_READ': {
                const { userID, deviceID, groupID, networkID } = action
                this.api.markAllMessagesRead(userID, deviceID, groupID, networkID)
                break
            }

            case 'FILE_OPEN':{
                const { jobID, networkID } = action
                const onLoad = url => {
                    try{
                        if(url){
                            const w = window.open(url)
                            w.onload = ()=>{
                                URL.revokeObjectURL(url)
                            }
                        }
                    }catch(e){

                    }
                }
                //const onLoad = url => {alert('window.open');}
                //console.log('onLoad')
                //console.log(onLoad)
                //onLoad()

                let job = getObjectByID(jobID, this.api.jobs, 'JobID')
                
                this.fileStorage.readFile(jobID, 1, networkID, onLoad, this.handleFileError.bind(this))
                break
            }

            case 'FILE_LOAD':{
                const { jobID, networkID } = action
                //const onLoad = url => {window.open(url)}
                //const onLoad = url => {alert('window.open');}
                //console.log('onLoad')
                //console.log(onLoad)
                //onLoad()
                this.fileStorage.readFile(jobID, 1, networkID, null, this.handleFileError.bind(this))
                break
            }

            case 'FILE_CANCEL':{
                const { jobID, networkID } = action
                this.api.cancelJob(jobID, networkID)
                break
            }

            case 'PREVIEW_OPEN':{
                const { jobID, networkID } = action
                const onLoad = url => {window.open(url)}
                this.fileStorage.readFile(jobID, 0, networkID, onLoad, this.handleFileError.bind(this))
                break
            }

            case 'PREVIEW_GET':{
                const { jobID, networkID, onLoad, onError } = action
                //console.log('PREVIEW_GET '+ jobID)
                this.fileStorage.readFile(jobID, 0, networkID, onLoad, onError) //this.handleFileError.bind(this)
                break
            }


            //emergency actions
            case 'CANCEL_EMERGENCY':{
                this.api.cancelEmergency(action.emergencyID)
                break
            }
            case 'SEND_EMERGENCY_ACK':{
                this.api.sendEmergencyAck(action.emergencyID)
                break
            }
            case 'LOCATE_EMERGENCY':{
                const emergency = getObjectByID(action.emergencyID, this.state.emergency, 'EmergencyID')
                if(emergency){
                    this.api.queryGpsDeviceRequest(emergency.NetworkID, emergency.DeviceID)
                }
                break
            }

            case 'STATISTICS_REQUEST':{
                this.api.queryStatistics(statistics => {
                    alert('set state statistics')
                    this.setState({
                        statistics: statistics
                    });
                });
                break;
            }

            case 'CHECK_PERMISSION':{
                //console.log('action');
                //console.log(action);
                const ret = this.api.checkPermission(action.networkID, action.permission);
                //console.log('ret');
                //console.log(ret);
                return ret;
                //break;
            }

            case 'TRACK_REQUEST':{
                let f = action.formData

                console.log('TRACK_REQUEST')
                console.log(f)

                const sqlRequest = new SqlRequest(action.networkID, action.onComplete)

                const userid = f.userID
                const speed = f.speedOver
                const accuracy = f.accuracy

                
                const dateFrom = f.dateFrom.getTime()
                const dateTo = f.dateTo.getTime()
                console.log('dateFrom')
                console.log(dateFrom)
                console.log('dateTo')
                console.log(dateTo)
                

                let where = "userid='" + base64toGuid(userid) + "'"
                where +=  " and dt >= @p1 and dt <= @p2"
                where += " and (accuracy is NULL or accuracy <= " + accuracy + ")"

                if (speed > 0){

                    const speedInMs = getSpeedInMs(speed)
                    console.log('speed '+speed)
                    console.log('speeed in ms '+speedInMs)
                    where += " and speed is NOT NULL and speed >= " + speedInMs;
                }

                const sql =  "select dt, latitude, longitude, '' as loc, speed, accuracy, CAST(0 AS FLOAT) as distance "+
                            "from locations "+
                            "where " + where + 
                            " order by dt"

                sqlRequest.addQuery("selectLocations", sql)
                console.log(sql)

                const ext1 = sqlRequest.parameterExtension('System.DateTime', "p1", dateFrom)
                const ext2 = sqlRequest.parameterExtension('System.DateTime', "p2", dateTo)

                sqlRequest.addExtension("selectLocations", ext1)
                sqlRequest.addExtension("selectLocations", ext2)


                this.api.querySql(sqlRequest)


                break
            }

            case 'SQL_REQUEST':{

                this.api.querySql(action.request)

                break
            }


            case 'RESOURCE_DOWNLOAD':{

                console.log('RESOURCE_DOWNLOAD')
                console.log(action)


                const onLoad = url => {
                    console.log('onLoad()')
                    console.log(url)
                    try{
                        if(url){

                            var a = document.createElement("a")
                            a.setAttribute("download", action.filename)
                            a.setAttribute("href", url);
                            //document.body.appendChild(a);
                            a.click()

                            //todo remove element

                            /*
                            const w = window.open(url)
                            //alert('window.open')
                            console.log('window.open')
                            console.log(url)
                            w.onload = ()=>{
                                URL.revokeObjectURL(url)
                            }
                            */
                        }
                    }catch(e){
                        alert('error')
                        console.log(e)
                    }
                }
                
                let mimeType = 'application/octet-stream'
                

                let resourceReader = new ResourceReader(
                    this.api, 
                    action.resourceType, 
                    action.resourceID, 
                    action.networkID,
                    action.name,
                    mimeType,
                    onLoad
                )
                
                resourceReader.run()

                //resourceReader.resourceRequest(action.resourceType, action.resourceID, action.networkID)
                //resourceReader.resourceRequest(action.resourceType, action.resourceID, action.networkID)

                break
            }

            case 'RESOURCE_GET':{

                console.log('RESOURCE_GET')
                console.log(action)


                const onLoad = url => {
                    console.log('onLoad()')
                    console.log(url)
                    try{
                        if(url){

                            action.onComplete(url, action.filename)

                            //var a = document.createElement("a")
                            //a.setAttribute("download", action.filename)
                            //a.setAttribute("href", url);
                            //document.body.appendChild(a);
                            //a.click()

                            //todo remove element

                            /*
                            const w = window.open(url)
                            //alert('window.open')
                            console.log('window.open')
                            console.log(url)
                            w.onload = ()=>{
                                URL.revokeObjectURL(url)
                            }
                            */
                        }
                    }catch(e){
                        alert('error')
                        console.log(e)
                    }
                }
                
                let mimeType = 'application/octet-stream'
                

                let resourceReader = new ResourceReader(
                    this.api, 
                    action.resourceType, 
                    action.resourceID, 
                    action.networkID,
                    action.name,
                    mimeType,
                    onLoad
                )
                
                resourceReader.run()

                //resourceReader.resourceRequest(action.resourceType, action.resourceID, action.networkID)
                //resourceReader.resourceRequest(action.resourceType, action.resourceID, action.networkID)

                break
            }

            case 'GROUP_PATCHES_DIALOG_SHOW':{
                this.setState({
                    groupPatchesDialog: {
                        groupPatches: this.api.groupPatches
                    }
                })
                break
            }

            //case 'SETTINGS_EDITOR_CLOSE':
            case 'GROUP_PATCHES_DIALOG_CLOSE':
                this.setState({
                    groupPatchesDialog: null
                })
                break

            case 'GROUP_PATCH_UPDATE':{
                this.api.queryGroupPatchUpdate(action.groupPatch, action.op)
                break
            }

            case 'GET_NETWORKS':{
                return this.state.networks
            }


            case 'GEOFENCE_UPDATE':{
                let geofence = action.geofence;


                let geofences = [...this.state.geofences]

                if(geofence.ID){
                    this.geofencesStorage.update(geofence.ID, geofence);

                    let index = getIndexByID(geofence.ID, geofences)
                    if(index!==null) geofences[index] = geofence
                }else{
                    geofence.ID = getBase64ID()
                    this.geofencesStorage.add(geofence);

                    geofences.push(geofence)
                }

                this.setState({geofences: geofences})
                break;
            }

            case 'GEOFENCE_DELETE':{
                let geofence = action.geofence
                if(geofence && geofence.ID){
                    //alert('GEOFENCE_DELETE')
                    this.geofencesStorage.delete(geofence.ID)

                    let geofences = [...this.state.geofences]
                    let index = getIndexByID(geofence.ID, geofences)
                    geofences.splice(index, 1)
                    this.setState({geofences: geofences})

                }
                break
            }

            case 'GEOFENCES_GET':{
                //alert('GEOFENCES_GET')
                //console.log('GEOFENCES_GET')

                this.geofencesStorage.query(null, action.onComplete, action.onError);

                //if(action.onChange) this.geofences.addEvent('onChange')

                break;
            }

            case 'GEOFENCE_SET_PROPERTY':{
                console.log('GEOFENCE_SET_PROPERTY')
                console.log(action)

                let geofence = getObjectByID(action.id, this.state.geofences) 
                geofence[action.name] = action.value

                let geofences = [...this.state.geofences]
                let index = getIndexByID(action.id, geofences)

                geofences[index] = geofence

                //this.setState({geofences: geofences})
                this.onGeofencesChange(geofences)

                this.geofencesStorage.update(geofence.ID, geofence);

                //this.props.onAction({type:'GEOFENCE_UPDATE', geofence: geofence})
                
                break;
            }

            case 'GEOFENCE_SWITCH_PAINT_TOOL':{

                if(this.state.geofencePaintID && this.state.geofencePaintID==action.id){
                    this.setState({geofencePaintID: null, geofenceSelectedShape: null})
                }else if(!this.state.geofencePaintID){
                    this.setState({geofencePaintID: action.id})
                }

                break;
            }

            case 'GEOFENCE_SELECT_SHAPE':{
                this.setState({geofenceSelectedShape: {id:action.id, index:action.index}})
                break
            }

            case 'GEOFENCE_ADD_SHAPE':{
                let geofence = getObjectByID(action.id, this.state.geofences) 

                let shapes = geofence.Shapes==undefined ? [] : geofence.Shapes.split('|')
                shapes.push(action.shape)

                geofence.Shapes = shapes.join('|')

                let geofences = [...this.state.geofences]
                let index = getIndexByID(action.id, geofences)

                geofences[index] = geofence

                //this.setState({geofences: geofences})
                this.onGeofencesChange(geofences)

                this.geofencesStorage.update(geofence.ID, geofence);

                break
            }

            case 'GEOFENCE_UPDATE_SHAPE': {
                //console.log(action)
                //alert('GEOFENCE_UPDATE_SHAPE')

                let geofence = getObjectByID(action.id, this.state.geofences) 

                let shapes = geofence.Shapes.split('|')
                shapes[action.index] = action.shape

                geofence.Shapes = shapes.join('|')

                let geofences = [...this.state.geofences]
                let index = getIndexByID(action.id, geofences)

                geofences[index] = geofence

                //this.setState({geofences: geofences})
                this.onGeofencesChange(geofences)

                this.geofencesStorage.update(geofence.ID, geofence);

                break
            }

            case 'GEOFENCE_DELETE_SHAPE': {
                let geofence = getObjectByID(action.id, this.state.geofences) 

                let shapes = geofence.Shapes.split('|')
                //shapes[action.index] = action.shape

                shapes.splice(action.index, 1)

                geofence.Shapes = shapes.join('|')

                let geofences = [...this.state.geofences]
                let index = getIndexByID(action.id, geofences)

                //this.setState({geofences: geofences})
                this.onGeofencesChange(geofences)

                this.geofencesStorage.update(geofence.ID, geofence)
                
                break
            }


            case 'KML_LAYER_UPDATE':{

                //console.log('KML_LAYER_UPDATE')
                //console.log(action)

                let kmlLayer = action.kmlLayer;

                let kmlLayers = [...this.state.kmlLayers]

                if(kmlLayer.ID){
                    this.kmlLayersStorage.update(kmlLayer.ID, kmlLayer);

                    let index = getIndexByID(kmlLayer.ID, kmlLayers)
                    if(index!==null) kmlLayers[index] = kmlLayer
                }else{
                    kmlLayer.ID = getBase64ID()
                    this.kmlLayersStorage.add(kmlLayer);

                    kmlLayers.push(kmlLayer)
                }

                this.updateKmlRefreshTimer(kmlLayer)

                this.setState({kmlLayers: kmlLayers})
                break;
            }

            case 'KML_LAYER_DELETE':{
                let kmlLayer = action.kmlLayer
                if(kmlLayer && kmlLayer.ID){
                    //alert('KML_LAYER_DELETE')
                    this.kmlLayersStorage.delete(kmlLayer.ID)

                    let kmlLayers = [...this.state.kmlLayers]
                    let index = getIndexByID(kmlLayer.ID, kmlLayers)
                    kmlLayers.splice(index, 1)
                    this.setState({kmlLayers: kmlLayers})

                }
                break
            }

            case 'KML_LAYERS_GET':{
                //alert('KML_LAYER_GET')
                //console.log('KML_LAYER_GET')

                this.kmlLayersStorage.query(null, action.onComplete, action.onError);

                //if(action.onChange) this.kmlLayers.addEvent('onChange')

                break;
            }

            case 'KML_LAYER_SET_PROPERTY':{
                //console.log('KML_LAYER_SET_PROPERTY')
                //console.log(action)

                let kmlLayer = getObjectByID(action.id, this.state.kmlLayers) 
                kmlLayer[action.name] = action.value

                let kmlLayers = [...this.state.kmlLayers]
                let index = getIndexByID(action.id, kmlLayers)

                kmlLayers[index] = kmlLayer

                //this.setState({kmlLayers: kmlLayers})
                this.onKmlLayersChange(kmlLayers)

                this.kmlLayersStorage.update(kmlLayer.ID, kmlLayer);

                //this.props.onAction({type:'KML_LAYER_UPDATE', kmlLayer: kmlLayer})
                
                break;
            }



            case 'ADD_ALERT':{
                this.alertLogger.add(action.fleetAlert)

                //todo add alert

                console.log('add alert')
                console.log(action)
                console.log(action.fleetAlert)

                /*
                DeviceID: "VCOCgm/6CWvvxDO5gVnsOw=="
                EmergencyID: "U+QOIHmSrEKH8tN/gOBiJg=="
                MessageID: "EMERGENCY"
                NetworkID: "duSxNqzebUm/47+LvWNFxA=="
                ProfileID: "EREREREREREREREREREREQ=="
                Reason: 0
                UserID: "sLm9gJYeQUmofciNJUapMw=="
                UserName: "user2"
                */

                /**
                 content: 'Speed out of range "vokzal" (173.3km/h)'
                datetime: 1748621840256
                dispatcherID: "EREREREREREREREREREREQ=="
                dispatcherName: "Administrator"
                fromID: "VCOCgm/6CWvvxDO5gVnsOw=="
                fromName: "user2"
                state: 0
                type: 3 
                */

                let emergencyAlert = {
                    MessageID: 'GEOFENCE_ALERT',
                    DeviceID: action.fleetAlert.fromID,
                    UserName: action.fleetAlert.fromName,
                    Reason: action.fleetAlert.type,
                    NetworkID: action.networkID
                }

                console.log('emergencyAlert')
                console.log(emergencyAlert)

                this.api.processEmergency(emergencyAlert)

                break
            }

            case 'MAP_CLICK':{

                this.geofenceLocator.process({
                    Latitude: action.lat, 
                    Longitude: action.lng,
                    ID: 'VCOCgm/6CWvvxDO5gVnsOw==',
                    Speed: Math.random()*100
                })

                break
            }

            case 'ALERT_DIALOG':{
                this.setState({alertDialog:{
                    open: true, 
                    message: action.message, 
                    title: action.title ? action.title : this.props.t('ServerConsole'),
                    onConfirm: action.onConfirm ? action.onConfirm : null
                }})
                break
            }
            
            case 'ALERT_DIALOG_CLOSE':{
                this.setState({alertDialog:{open: false, message: '', title: ''}})
                break
            }


            default: dev.alert('FleetConsole: App action [' + action.type + '] not defined')

        }

    }

    onGeofencesChange(geofences){

        this.setState({geofences: geofences})


        this.geofenceLocator.setGeofences(geofences)

        //this.geofenceLocator.setGeofences(geofences)

    }

    handleFileError(jobID, type, errorCode, fileID, networkID, onsuccess){
        switch(errorCode){
            case 1: {//empty data
                console.error('handleFileError queryEmptyData ' + jobID + '; type='+type)
                this.api.queryGetJobData(jobID, type, fileID, networkID, onsuccess)
                break
            }
            case 2: {// file is absent (not yet uploaded)
                console.error('handleFileError queryAbsentFile ' + jobID + '; type='+type)
                this.api.queryGetJobData(jobID, type, fileID, networkID, onsuccess)
                break
            }
            default:
                console.error('handleFileError: unexpected errorCode ' + errorCode)
        }
    }

    handleAvatarUpdate(hash, avatar, networkID) {
        if (this.state.userPropertiesDialog && this.state.userPropertiesDialog.deviceID) {
            const network = getObjectByID(networkID, this.state.networks)
            const device = getObjectByID(this.state.userPropertiesDialog.deviceID, network.devices)
            if (device && device.AvatarHash === hash) {
                this.setState({
                    userPropertiesDialog: { ...this.state.userPropertiesDialog, avatar: avatar }
                })
            }
        }
    }

    handlePttCall(calls, activeCallID) {
        this.setState({ calls: calls })
        this.forceUpdate()
    }

    handleUnreadMessagesChanged(messages) {
        //console.log('handleUnreadMessagesChanged')
        //console.log(messages)
        this.setState({ unreadMessages: messages })
    }

    handleEmergency(emergency){
        //console.log('handleEmergency')
        //console.log(emergency)
        this.setState({ emergency: emergency })
    }

    render() {

        const { i18n } = this.props;

        if (this.state.isConnecting) {
            return (
                <ConnectionProgress apiError={this.state.apiError} 
                        apiMessage={this.state.apiMessage} 
                        onAction={this.handleAppAction} />
            )
        } else if (this.state.page === 'login'){
            return (
                <Container height="100vh" style={{ paddingTop: '2em' }}>
                    <Login onLogin={this.handleLogin.bind(this)}
                        login={this.state.authUser.login}
                        password={this.state.authUser.password}
                        serveraddress={this.state.authUser.serveraddress}
                        lang={getLang(i18n)}
                    />
                </Container>
            );
        } else {


            let alertDialog = this.state.alertDialog && this.state.alertDialog.open ? (
                <AlertDialog {...this.state.alertDialog} onAction={this.handleAppAction}></AlertDialog>
            ):''

            //console.log('this.state.dynamicGroupPropertiesDialog')
            //console.log(this.state.dynamicGroupPropertiesDialog)
            
            return(
                <>
                {alertDialog}
                <ServerConsole
                        settings={this.settings}
                        networks={this.state.networks}
                        user={this.state.authUser}
                        onAction={this.handleAppAction}
                        statusError={this.state.apiError}
                        statusMessage={this.state.apiMessage}
                        eventLogger={this.eventLogger}
                        alertLogger={this.alertLogger}
                        calls={this.state.calls}
                        unreadMessages={this.state.unreadMessages}
                        emergency={this.state.emergency}

                        settingsDialog={this.state.settingsDialog}
                        deviceSettingsEditor={this.state.deviceSettingsEditor}
                        userPropertiesDialog={this.state.userPropertiesDialog}
                        groupPropertiesDialog={this.state.groupPropertiesDialog}
                        dynamicGroupPropertiesDialog={this.state.dynamicGroupPropertiesDialog}
                        groupPatchesDialog={this.state.groupPatchesDialog}
                        networkEditor={this.state.networkEditor}
                        geofences={this.state.geofences}
                        geofencePaintID={this.state.geofencePaintID}
                        geofenceSelectedShape={this.state.geofenceSelectedShape}
                        kmlLayers={this.state.kmlLayers}
                    />
                </>
            )
            
/*
            switch (this.state.page) {
                
                case 'login':
                    return (
                        <Container height="100vh" style={{ paddingTop: '2em' }}>
                            <Login onLogin={this.handleLogin.bind(this)}
                                login={this.state.authUser.login}
                                password={this.state.authUser.password}
                                serveraddress={this.state.authUser.serveraddress}
                                lang={getLang(i18n)}
                            />
                        </Container>
                    );
                    

                case 'networkeditor':
                    //onLogout={this.handleLogout.bind(this)}
                    return (
                        <NetworkEditor
                            networks={this.state.networks}
                            networkID={this.state.networkEditor.networkID}
                            networkSettings={this.state.networkEditor.networkSettings}
                            user={this.state.authUser}

                            onAction={this.handleAppAction}
                            statusError={this.state.apiError}
                            statusMessage={this.state.apiMessage}></NetworkEditor>
                    );

                case 'console':
                default:
                    //console.log('render ServerConsole')
                    //console.log(this.state.emergency)
                    return (
                        <ServerConsole
                            settings={this.settings}
                            networks={this.state.networks}
                            user={this.state.authUser}
                            onAction={this.handleAppAction}
                            statusError={this.state.apiError}
                            statusMessage={this.state.apiMessage}
                            eventLogger={this.eventLogger}
                            calls={this.state.calls}
                            unreadMessages={this.state.unreadMessages}
                            emergency={this.state.emergency}

                            settingsDialog={this.state.settingsDialog}
                            deviceSettingsEditor={this.state.deviceSettingsEditor}
                            userPropertiesDialog={this.state.userPropertiesDialog}
                            groupPropertiesDialog={this.state.groupPropertiesDialog}
                        />
                    );
            }
            */
        }
    }
}

export const FleetConsole = withTranslation()(FleetConsole_);